import styled from 'styled-components';

const DashboardWrapper = styled.div`
    .major-statistics {
        padding: 10px 0;
    }
    .recent-and-shortcuts-wrapper {
        padding: 10px;
    }
`;

export default DashboardWrapper


// WEBPACK FOOTER //
// ./src/components/Main/Dashboard/Dashboard.style.js